/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Source_GamepadInputs */



/**
* | output |
* | --- |
* | "Gamepad / Joystick" |
*
* @param {Options_Pedal_Source_GamepadInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_source_gamepad = /** @type {((inputs?: Options_Pedal_Source_GamepadInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Source_GamepadInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gamepad / Joystick")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gamepad / Joystick")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gamepad / Joystick")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Gamepad / Joystick")
	if (locale === "es") return /** @type {LocalizedString} */ ("Gamepad / Joystick")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Gamepad / Joystick")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Gamepad / Joystick")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Gamepad / Joystick")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gamepad / Joystick")
	return /** @type {LocalizedString} */ ("Gamepad / Joystick")
});